import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FilesViewConstants } from './files/file-view-context';
import { HomeComponent } from './home.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AuthGuard } from './shared/authentication/auth-guard.service';
import { FilePickerComponent } from './shared/file-picker/file-picker.component';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          redirectTo: 'alerts',
          pathMatch: 'full',
        },
        {
          path: 'alerts',
          loadChildren: () => import('./alert/alert.module').then((m) => m.AlertModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'call-center',
          loadChildren: () => import('./call-center/call-center.module').then((m) => m.CallCenterModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'contacts',
          loadChildren: () => import('./contacts/contacts.module').then((m) => m.ContactsModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'admin',
          loadChildren: () => import('./hickory/hickory.module').then((m) => m.HickoryModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'admins',
          loadChildren: () => import('./admins/admins.module').then((m) => m.AdminsModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'groups',
          loadChildren: () => import('./groups/groups.module').then((m) => m.GroupsModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'incidents',
          loadChildren: () => import('./incident/incident.module').then((m) => m.IncidentModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'incidents-v2',
          loadChildren: () => import('./incident-v2/incident-v2.module').then((m) => m.IncidentV2Module),
          canActivate: [AuthGuard],
        },
        {
          path: 'incident-guide',
          loadChildren: () => import('./incident-guide/incident-guide.module').then((m) => m.IncidentGuideModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'jobs',
          loadChildren: () => import('./jobs/jobs.module').then((m) => m.JobsModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'bcp',
          loadChildren: () => import('./bcp/bcp.module').then((m) => m.BcpModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'ipaws',
          loadChildren: () => import('./bamboo/bamboo.module').then((m) => m.BambooModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'questionnaire',
          loadChildren: () => import('./questionnaire/questionnaire.module').then((m) => m.QuestionnaireModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'roles',
          loadChildren: () => import('./role/role.module').then((m) => m.RoleModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'tasklists',
          loadChildren: () => import('./tasklist/tasklist.module').then((m) => m.TasklistModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'internal',
          loadChildren: () => import('./internal/internal.module').then((m) => m.InternalModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'tenant',
          loadChildren: () => import('./tenant/tenant.module').then((m) => m.TenantModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'disclaimer',
          loadChildren: () => import('./disclaimer/disclaimer.module').then((m) => m.DisclaimerModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'content',
          loadChildren: () => import('./walnut/walnut.module').then((m) => m.WalnutModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'back-office',
          loadChildren: () => import('./back-office/back-office.module').then((m) => m.BackOfficeModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'surveys',
          loadChildren: () => import('./surveys/surveys.module').then((m) => m.SurveysModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'component-library',
          loadChildren: () =>
            import('./component-library/component-library.module').then((m) => m.ComponentLibraryModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'jobs',
          loadChildren: () => import('./jobs/jobs.module').then((m) => m.JobsModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'reports',
          loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'weather',
          loadChildren: () => import('./weather/weather.module').then((m) => m.WeatherModule),
          canActivate: [AuthGuard],
        },
        {
          path: 'socialMedia',
          loadChildren: () => import('./social-media/social-media.module').then((m) => m.SocialMediaModule),
          canActivate: [AuthGuard],
          data: { name: 'Social Media' }
        },
        {
          path: 'pronunciations',
          loadChildren: () => import('./pronunciation/pronunciation.module').then((m) => m.PronunciationModule),
          canActivate: [AuthGuard],
          data: { name: 'Custom Pronunciation' }
        },
        {
          path: 'sftp',
          loadChildren: () => import('./sftp/sftp.module').then((m) => m.SftpModule),
          canActivate: [AuthGuard],
          data: { name: 'File Imports (SFTP)' }
        },
        {
          path: 'dashboard',
          component: HomeComponent,
          canActivate: [AuthGuard],
          data: { name: 'Dashboard' },
        },
        {
          path: 'files',
          loadChildren: () => import('./files/files.module').then((m) => m.FilesModule),
          canActivate: [AuthGuard],
          data: { name: 'Nav.Bickory.Files', permissions: ['hickory.FilesManage'] },
        },
        {
          path: FilesViewConstants.RTE_ROUTE,
          component: FilePickerComponent,
          canActivate: [AuthGuard],
          data: { name: 'File Picker' },
        },
        {
          path: '**',
          component: PageNotFoundComponent,
          data: { name: 'NotFound.Title' },
        },
      ],
      {
        useHash: true,
      },
    ),
  ],
  exports: [RouterModule],
})
export class RoutingModule { }
